// extracted by mini-css-extract-plugin
export default {"overridesPrimaryActionButton":"PrimaryActionButton-module--overrides--PrimaryActionButton--rVxZw"};